import { type TooltipState, type TooltipItem, type TOOLTIP_Key, TooltipStateKey } from './symbols'

export function useTooltip() {
  const tooltipState = inject(TooltipStateKey) as TooltipState

  const setTooltips = (tooltip: TooltipItem) => {
    tooltipState.tooltipItems.value.set(tooltip.uuid, tooltip)
  }
  const checkIsOpen = (key: TOOLTIP_Key) => {
    return tooltipState.tooltipItems.value.get(key)?.isOpen
  }
  const changeTooltips = (key: TOOLTIP_Key, state: boolean | null = null) => {
    for (const [mapKey, mapValue] of tooltipState.tooltipItems.value) {
      if (mapKey === key) mapValue.isOpen = state === null ? !mapValue.isOpen : state
      else mapValue.isOpen = false
    }
  }

  return {
    ...tooltipState,
    setTooltips,
    checkIsOpen,
    changeTooltips
  }
}
